import api from "./axios";

// ── Public ──────────────────────────────────────────────────────────────────
export const getResources = (params) => api.get("/api/resources/", { params });
export const getResource  = (slug)   => api.get(`/api/resources/${slug}/`);

// ── Admin Resources ──────────────────────────────────────────────────────────
export const adminGetResources    = (params) => api.get("/api/admin/resources/", { params });
export const adminGetResourceById = (id)     => api.get(`/api/admin/resources/${id}/`);
export const adminCreateResource  = (formData) =>
  api.post("/api/admin/resources/", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
export const adminUpdateResource  = (id, data) => api.put(`/api/admin/resources/${id}/`, data);
export const adminDeleteResource  = (id)       => api.delete(`/api/admin/resources/${id}/`);

// ── Admin Resource Categories ────────────────────────────────────────────────
export const adminGetResourceCategories      = ()          => api.get("/api/admin/resource-categories/");
export const adminGetResourceCategoryById    = (id)        => api.get(`/api/admin/resource-categories/${id}/`);
export const adminCreateResourceCategory     = (data)      => api.post("/api/admin/resource-categories/", data);
export const adminUpdateResourceCategory     = (id, data)  => api.put(`/api/admin/resource-categories/${id}/`, data);
export const adminDeleteResourceCategory     = (id)        => api.delete(`/api/admin/resource-categories/${id}/`);